import { getAuthToken } from '../sagas/utils';

export default {
  auth: {
    data: { authToken: getAuthToken() },
  },
  user: {
    signUp: {},
    patchAddress: {},
    toggleMfaConfig: {},
    authenticated: {},
    login: {},
    confirmMfaCode: {},
    resendMfaCode: {},
    forgotPassword: {},
    resetPassword: {},
    emailChange: {},
    emailConfirm: {},
    updatePhoneNumber: {},
  },
  accounts: {
    list: [],
    item: {},
    refresh: {},
    create: {},
    patch: {},
    patchJointInterest: {},
    patchBeneficiaries: {},
    updateSuitabilityInformation: {},
    updateFinancialAssets: {},
    submit: {},
    updateSignature: {},
    switch: {},
    link: {},
  },
  accountHolders: {
    patch: {},
    createPhysicalAddress: {},
    patchPhysicalAddress: {},
    createMailingAddress: {},
    patchMailingAddress: {},
    createTrustedContact: {},
    patchTrustedContact: {},
    deleteTrustedContact: {},
    createFinancialInformationEmployment: {},
    patchFinancialInformationEmployment: {},
    createDisclosures: {},
    patchDisclosures: {},
  },
  accountDetails: {
    accountBalance: {},
    accountValue: {},
    withdrawalFunds: {},
  },
  accountApplications: {
    details: {},
    deleteDocument: {},
    cancelDocument: {},
  },
  statements: {
    tradeConfirmations: {
      list: {},
      downloads: [],
    },
    monthlyStatements: {
      list: {},
      downloads: [],
    },
    taxDocuments: {
      list: {},
      downloads: [],
    },
  },
  cashiering: {
    achRelationships: {},
    createACHRelationship: {},
    editACHRelationship: {},
    unlinkACHRelationship: {},
    plaidLinkToken: {},
    transfers: {},
    transferDetails: {},
    cancelDeposit: {},
    cancelWithdraw: {},
  },
  offers: {
    offersList: {},
    offerDetails: {},
    offerDocuments: {},
    options: {},
  },
  offerWatches: {
    list: {},
    createOfferWatch: {},
    deleteOfferWatch: {},
  },
  investigations: {
    list: {},
  },
  configs: {
    configsList: {},
  },
  quotes: {
    list: {},
    details: {},
    chart: {},
  },
  orders: {
    details: {},
    list: {},
    create: {},
    cancel: {},
    cumulativeList: {},
  },
  positions: {
    list: {},
  },
  offerOrders: {
    details: {},
    list: {},
    create: {},
    update: {},
    cancel: {},
    fail: {},
    complete: {},
    createCardPaymentIntent: {},
    updateCardPaymentIntent: {},
    submitCardPayment: false,
    confirmCardPayment: {},
    intent: null,
  },
  toastMessages: {
    list: [],
    clearList: [],
    open: null,
    close: null,
  },
  app: {
    lastMfaCodeSentAt: null,
    redirectToOffer: null,
    redirectToOfferOrder: null,
    redirectToEmailConfirm: null,
    onboardStep: null,
    offerInvestReferrer: null,
    accountApplicationCategoryViewList: [],
    redirectToSummary: false,
    redirectToCompleteAccountAfterSubmit: false,
    redirectToLinkAccount: false,
  },
};
